import React from 'react';
import Navbar from './components/Navbar';
import Deve from './components/Deve';
import About from './components/About';
import Architecture from './components/Architecture';
import Projects from './components/Projects';
import AIBanking from './components/AIBanking';
import AIRetail from './components/AIRetail';
import Stack from './components/Stack';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ModalManager from './modals/ModalManager';

//import { useModal } from "./components/ModalProvider";
//import ModalRoot   from "./components/ModalRoot";
// export default function App() {
//   return (
//     <div className="text-red-500 text-4xl">
//       Tailwind Test
//     </div>
//   );
// } 

//  export default function App() {

//   return (
//     <React.StrictMode>
//       <ModalProvider>
//        <div className="relative">
//           const modal = useModal();
//           console.log("APP MODAL:", modal);
//           <div>App</div>
          
//           <ModalRoot />
//         </div>
//       </ModalProvider>
//     </React.StrictMode>  
//   )
// } 


export default function App() {
    return (
      <div className="relative">
        <Navbar />
        <Deve />
        <About />
        <Architecture />
        <Projects />
        <AIBanking />
        {/* <AIRetail /> */}
        <Stack />
        <Contact />
        <Footer />
        <ModalManager/>
      </div>
    );
}

//import BuyButton from './BuyButton';
//import ModalManager from './modals/ModalManager';

// export default function App() {
  
//   console.log("APP MODAL:");

//   return (
//     <div className="app-container">
//       App button
//       <button>Clicked  times</button>
//       <BuyButton/>
//       <ModalManager/>
//     </div>
//   );
// }